import React, { useState, useContext } from 'react';
import ThemeContext from '../context/theme.Context';
import LocationsContext from '../context/locations.Context';
import LoadingContext from '../context/loading.context';
import UserDetailsContext from '../context/userDetails.context';
import NotificationContext from '../context/notification.Context';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import * as Constants from '../modules/constants';


const AssignDeviceToGroup = function (props) {

    const { showLoading, hideLoading } = useContext(LoadingContext);
    const { locations, setGroupDevices } = useContext(LocationsContext);
    const { token } = useContext(UserDetailsContext);
    const { showMessage } = useContext(NotificationContext);

    const [buttonDisabled, setButtonDisabled] = useState(true);

    const [availableGroups, setAvailableGroups] = useState(getAvailableGroups(props.location.state.locationId, props.location.state.deviceId));
    const [successMessage, setSuccessMessage] = useState('');

    const apiHostName = Constants.API_URL;



    // Get all groups for this location, where the specified device is not already assigned to the group
    function getAvailableGroups(locationId, deviceId) {

        const availableGroups = {};
        Object.values(locations[locationId].groups).forEach(group => {
            if (group.deviceIDs.includes(deviceId)) {
                // Device ID is assigend to this group, so skip this one...
            }
            else {
                availableGroups[group.id] = { ...group };
                availableGroups[group.id].isChecked = false;
                availableGroups[group.id].visible = true;
            }
        });
        return availableGroups;
    }

    function setButtonDisabledState() {
        // Checkif at least 1 checkbox is selected now:
        var selectedCount = 0;
        Object.values(availableGroups).forEach(group => group.visible && group.isChecked ? selectedCount++ : null);
        if (selectedCount > 0)
            setButtonDisabled(false);
        else
            setButtonDisabled(true);
    }

    function listHeader() {
        // Checkif at least 1 checkbox is selected now:
        var visibleCount = 0;
        Object.values(availableGroups).forEach(group => group.visible ? visibleCount++ : null);
        if (visibleCount > 0)
            return 'Select the group(s) you want to assign this device to:';
        else
            return 'There are no groups available to add this device to.';
    }

    function toggleCheckbox(e) {

        // update the availableGroups object list to set the "isChecked" property to true or false for the selected group:
        const groupId = e.target.name;
        const checkValue = e.target.checked;

        //var updatedState;
        setAvailableGroups(prevState => {
            availableGroups[groupId].isChecked = checkValue;    // Note: this runs asynchronously, so we need to get the event target properties outside this function!

            // Also because this runs asynchronously: we need to process this inside this setState function:
            setButtonDisabledState();

            return availableGroups;
        });

    }



    function handleSubmit(event) {
        event.preventDefault();
        setButtonDisabled(true);
        showLoading();

        // Send request to server:
        Object.values(availableGroups).forEach(group => {
            if (group.visible && group.isChecked) {
                showLoading();
                fetch(apiHostName + '/v1/devices/' + props.location.state.deviceId + '/associate-group?groupId=' + group.id, {
                    mode: "cors",
                    method: 'PUT', headers: { "Authorization": "Bearer " + token }
                })
                    .then(function (response) {
                        if (!response.ok) {
                            return response.text();
                        }
                        return new Promise(function (resolve, reject) { resolve("OK"); });
                    })
                    .then((result) => {
                        // Result contains a text message that the action was successful - ignore this...
                        if (result !== "OK") {
                            showMessage({ newMessage: "Error: " + result });
                        }
                        else {
                            // Ok... Update data...
                            var deviceIDs = [];
                            deviceIDs = [...group.deviceIDs];
                            deviceIDs.push(props.location.state.deviceId);
                            setGroupDevices(props.location.state.locationId, group.id, deviceIDs);
                            group.visible = false;
                            setAvailableGroups(availableGroups);
                            hideLoading();
                            setButtonDisabledState();
                            setSuccessMessage('Device has successfully been added to group(s).');
                        }
                    })
                    .catch(function (error) {
                        // Set visual cue and error text to be displayed on login screen
                        console.error("Cannot associate device to group...");
                        console.error(error);
                        showMessage({ newMessage: 'Network error' });
                        hideLoading();
                        setButtonDisabledState();
                    });

            }

        });
        hideLoading();

    }

    return (
        <ThemeContext.Consumer>
            {(themeContext) => (
                <Card bg={themeContext.theme} text={themeContext.textColor}>
                    <Card.Body>
                        <Card.Title>
                            Assigning device to group(s)
                        </Card.Title>
                        <Card.Subtitle>
                            Device: {props.location.state.description} (ID: {props.location.state.deviceId})
                        </Card.Subtitle>
                        <Card.Text as="div" style={{paddingTop: '2em'}}>
                            <div>{listHeader()}</div>
                            <Form noValidate onSubmit={(event) => { handleSubmit(event); }}>
                                {Object.values(availableGroups).map(group => {
                                    return group.visible ?
                                        <Form.Check label={group.name} key={group.id} name={group.id} onChange={(e) => { toggleCheckbox(e); }} />
                                        : '';
                                })}
                                <Button variant='secondary' style={{ marginTop: '1em' }} title="Assign device to selected group(s)" disabled={buttonDisabled} type="submit">Assign group(s)</Button>
                            </Form>
                            <div style={{ paddingTop: '2em' }}>{successMessage}</div>
                        </Card.Text>
                    </Card.Body>
                </Card>
            )}
        </ThemeContext.Consumer>
    );
};


export default AssignDeviceToGroup;



// WEBPACK FOOTER //
// ./src/components/AssignDeviceToGroup.js